let Search = function (text, categories) {
    this.text = text || '';
    this.link = text ? encodeURIComponent(text) : '';
    this.categories = categories || [];
};

export default Search;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/search.js